/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AdminCreateSurveyMarkDraft } from '../../models/admin-create-survey-mark-draft';
import { SurveyMarksDraftsDto } from '../../models/survey-marks-drafts-dto';

export interface AdminCreateSurveyMarkDraft$Params {
  body: AdminCreateSurveyMarkDraft;
}

export function adminCreateSurveyMarkDraft(
  http: HttpClient,
  rootUrl: string,
  params: AdminCreateSurveyMarkDraft$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarksDraftsDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    adminCreateSurveyMarkDraft.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarksDraftsDto>;
      }),
    );
}

adminCreateSurveyMarkDraft.PATH = '/admin/surveyMarks/drafts';
